/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_No_DistanceInputs */

const en_ui_laps_row_no_distance = /** @type {(inputs: Ui_Laps_Row_No_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splits unavailable`)
};

const de_ui_laps_row_no_distance = /** @type {(inputs: Ui_Laps_Row_No_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Splits nicht verfügbar`)
};

/**
* | output |
* | --- |
* | "Splits unavailable" |
*
* @param {Ui_Laps_Row_No_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_no_distance = /** @type {((inputs?: Ui_Laps_Row_No_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_No_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_no_distance(inputs)
	return de_ui_laps_row_no_distance(inputs)
});